import { setValidateTriggered } from "redux/formDisplay";
import { compareData } from "helper/calculateNetAsset";
import { matchDetails } from "helper/calculateNetAsset";
import determineRequired from "helper/validateRequired";

export const validate = async(fields, selectedData,dispatch,staticData,workflowUser,recursive,data,config,role_id,assign_approval_to,assigned_dynamic_step) => {

   let required;
    let errs = {};
    let err = false;
    const modules = ['video_kyc','esign', 'template','estamp']
    const IndirectEval = (evalString) =>{
        // const selectedData = useSelector((state)=>state.formData.selectedData)
            return eval(evalString)
    }
    const checkStatus = (value_1,value_2,arr) => {
      return compareData(value_1,value_2,arr)
    }
    const processValidation = async (name) => {
      if (name === "assign_approval_to" && !selectedData?.assign_approval_to) {       
          required = await determineRequired(selectedData, config, selectedData?.step_history,assign_approval_to,assigned_dynamic_step);
      }
      return required;
  };

  const validationPromises = Object.keys(fields).map(async (key) => {
        const _field = fields[key];
        const { name, label, dependent, error_messages,type,validators,approval_type} = _field;
         required = IndirectEval(_field?.validators?.required);
        let pattern = _field?.validators?.pattern
        if (name === "assign_approval_to" && !selectedData?.assign_approval_to || approval_type == "parallel") {
          required = await processValidation(name);
        }
       

        let selectedVal = selectedData[name];
        let  min_length = IndirectEval(_field?.validators?.min_length), max_length = IndirectEval(_field?.validators?.max_length)
        let min_value= IndirectEval(_field?.validators?.min_value)
        let is_unique = validators?.is_unique
        let signer_unique = validators?.signer_unique
        if (name && name?.length !== 0) {
            if (required ) {
              if(type == "dropdown" &&  selectedVal== "Select" ){
                errs[name] = { err: error_messages?.required_error || `This field is required`};

              }
                if (dependent?.expression) {
                    if (IndirectEval(dependent?.expression)) {
                        if (!selectedVal || selectedVal?.length === 0 || selectedVal === undefined) {
                            errs[name] = { err: error_messages?.required_error };
                        }
                    }
                    
                } else if (!selectedVal || selectedVal?.length === 0 || selectedVal === undefined ){
                    errs[name] = { err: error_messages?.required_error || `This field is required` };
                } if(min_length?.length !== 0 && selectedVal?.length < min_length && !errs.hasOwnProperty(name) && type !='mobile' && type !='telephone' && type!= 'date' && type != 'datepicker'){
                  let pattern = /{(.*?)\}/;
                  if(pattern.test(error_messages?.min_error)){
                    let regex = "{(.*?)\}";
                    let matchedPattern = error_messages?.min_error?.match(regex)[1];
                    let data = eval(matchedPattern);
                    errs[name] = { err: eval(error_messages?.min_error.replace(pattern,data)) }
                  } else errs[name] = { err:  error_messages?.min_error ||`${label} should be minimum ${min_length} character` }
                 }else if( min_value && !errs.hasOwnProperty(name) && type !='mobile' && type !='telephone' && type!= 'date' && type != 'datepicker'){
                  const value = Number(selectedVal.replaceAll(',',''))
                  if(parseInt(value)<parseInt(min_value)){
                  errs[name] = { err: error_messages?.min_value_error || `${label} should be minimum ${min_value} USD` }
                  }
                  }
                  }
            if(max_length?.length !== 0 && selectedVal?.length > max_length && !errs.hasOwnProperty(name) && type !='mobile' && type !='telephone' && type != 'date' && type != 'datepicker'){
              let pattern = /{(.*?)\}/;
              if(pattern.test(error_messages?.max_error)){
                let regex = "{(.*?)\}";
                let matchedPattern = error_messages?.max_error?.match(regex)[1];
                let data = eval(matchedPattern);
                errs[name] = { err: eval(error_messages?.max_error.replace(pattern,data)) }
              } else errs[name] = { err: error_messages?.max_error ||`${label} should be maximum ${max_length} character` }
            }
            if(selectedVal?.length !== 0 && min_length?.length !== 0 && selectedVal?.length < min_length && !errs.hasOwnProperty(name) && type !='mobile' && type !='telephone' && type!= 'date' && type != 'datepicker'){
              let pattern = /{(.*?)\}/;
              if(pattern.test(error_messages?.min_error)){
                let regex = "{(.*?)\}";
                let matchedPattern = error_messages?.min_error?.match(regex)[1];
                let data = eval(matchedPattern);
                errs[name] = { err: eval(error_messages?.min_error.replace(pattern,data)) }
              } else errs[name] = { err:  error_messages?.min_error ||`${label} should be minimum ${min_length} character` }
             }else if( min_value && !errs.hasOwnProperty(name) && type !='mobile' && type !='telephone' && type!= 'date' && type != 'datepicker'){
              const value = Number(selectedVal?.replaceAll(',','') || 0)
              if(parseInt(value)<parseInt(min_value)){
              errs[name] = { err: error_messages?.min_value_error || `${label} should be minimum ${min_value} USD` }
              }
              }

            //mobile min and max length validation 
            if(type =='mobile' && selectedVal && selectedVal?.length != 0 && !errs.hasOwnProperty(name) ){
              let mobilearr = selectedVal?.split("-")
              let countryDetails = matchDetails("calling_code",mobilearr[0],staticData?.countryData)
              if(countryDetails?.minLen && mobilearr[1].length < countryDetails?.minLen){
                errs[name] = { err:  `${label} should be minimum ${countryDetails?.minLen} character` }
              }
              else if(countryDetails?.maxLen && mobilearr[1].length > countryDetails?.maxLen){
                errs[name] = { err:  `${label} should be maximum ${countryDetails?.maxLen} character` }
              }
              else if (pattern && pattern?.length !== 0 &&  mobilearr[1]?.length > 0) {
                var regex_pattern = new RegExp(pattern);
                if (!regex_pattern.test(mobilearr[1])) {
                    errs[name] = { err: error_messages?.pattern_error ||`Pattern mismatch` };
                }
              }
              if(required && mobilearr[1].length == 0 && mobilearr[0].length == 0 ){
                errs[name] = { err: error_messages?.required_error || `This field is required` };
              }
              else if(mobilearr[1].length != 0 && mobilearr[0].length == 0 ){
                if (dispatch  && typeof dispatch === "function") {
                  dispatch(setValidateTriggered(true));
                }
                let callCodeErr = `${name}_code`
                errs[callCodeErr] = { err:  `This field is required` }
              }
              else if(mobilearr[1].length == 0 && mobilearr[0].length != 0 ){
                errs[name] = { err: error_messages?.required_error || `This field is required` };
              } 
            }

            //Telephone  validation 
            if(type =='telephone' && selectedVal && selectedVal?.length != 0 && !errs.hasOwnProperty(name) ){
              let mobilearr = selectedVal?.split("-")
              let telephoneNum = mobilearr[1], telephoneCode = mobilearr[0]
              if(min_length?.length !== 0 && telephoneNum.length !=0 && telephoneNum.length < min_length){
                errs[name] = { err: error_messages?.min_error || `${label} should be minimum ${min_length} character` }
              }
              else if(max_length?.length !== 0 && telephoneNum.length > max_length ){
                errs[name] = { err: error_messages?.max_error || `${label} should be maximum ${max_length} character` }
              }
              else if (pattern && pattern?.length !== 0  && telephoneNum?.length > 0 ) {
                var regex_pattern = new RegExp(pattern)
                if (!regex_pattern.test(telephoneNum)) {
                    errs[name] = { err: error_messages?.pattern_error ||`Pattern mismatch` };
                }
              }
              if(required && telephoneNum.length == 0 && telephoneCode.length == 0 ){
                errs[name] = { err: error_messages?.required_error || `This field is required` };
              }
              else if(telephoneNum.length != 0 && telephoneCode.length == 0 ){
                let callCodeErr = `${name}_code`
                errs[callCodeErr] = { err:  `This field is required` }
              }
              else if(telephoneNum.length == 0 && telephoneCode.length != 0 ){
                errs[name] = { err: error_messages?.required_error || `This field is required` };
              }
              
            }

            if(is_unique && recursive && selectedVal && is_unique == true ){
              recursive?.saveData.map((item,index) =>{
                if(!(typeof(recursive?.editIndex) == 'number' && recursive?.editIndex >= 0 && index == recursive?.editIndex)){
                  if(type == 'upload'){
                    if(item?.verification_response[name].document_number == selectedData?.verification_response[name].document_number){
                      errs[name] = { err: error_messages?.unique_error || `${label} should be unique` };
                    }
                  }else {
                    if(item[name]?.toLowerCase() == selectedVal?.toLowerCase()){
                      errs[name] = { err: error_messages?.unique_error || `${label} should be unique` };
                    }
                  }
                }
              })
            }

            if(signer_unique && signer_unique == true && data && selectedVal){
              let primaryApplicant = data.signers_info[0]
              let SignerData  = [primaryApplicant]
              if(recursive?.signerParams?.hasOwnProperty("signer_validation_name")){
                recursive?.signerParams?.signer_validation_name?.map((item)=>{
                  if(data[item]){
                    SignerData = [...SignerData,...data[item]]
                  }
                })
              }
              // console.log("🚀 ~ file: validate.js:142 ~ validate ~ SignerData:", SignerData)
              SignerData?.map((item)=>{
                if(type == 'text' && item[name] && item[name]?.toLowerCase() == selectedVal?.toLowerCase()){
                  errs[name] = { err: error_messages?.unique_error || `${label} should be unique` };
                  
                } else if(type == 'mobile' && item[name]){
                  if(name == 'signer_mobile' && selectedVal.includes('-')){
                    selectedVal = selectedVal?.replace("-", "")
                  }
                  if(item[name] == selectedVal){
                    errs[name] = { err: error_messages?.unique_error || `${label} should be unique` };
                  }
                  
                } else if(type == 'email' && item[name] && item[name] == selectedVal){
                  errs[name] = { err: error_messages?.unique_error || `${label} should be unique` };
                }
              }) 
            }
            //pattern match
            if (pattern && pattern?.length !== 0 && !errs.hasOwnProperty(name) && selectedVal?.length > 0 && type !='mobile' && type !='telephone'  && type != 'input_tags') {
              var regex_pattern = new RegExp(pattern);
              if (!regex_pattern.test(selectedVal)) {
                  errs[name] = { err: error_messages?.pattern_error ||`Pattern mismatch` };
              }
            }

            if (type == 'date' && selectedVal && selectedVal.length !== 0 && !errs.hasOwnProperty(name)) {
              const [day, month, year] = selectedVal.split('/');
              if (parseInt(year) < 1000) {
                errs[name] = "Invalid year, it should be greater than 1000";
              } 
            }
            
          }
        else if (
          (!selectedVal ||
            selectedVal?.length === 0 ||
            selectedVal === undefined ) && name
          ) {
            errs[name] = {
              err: error_messages?.required_error || `This field is required`,
            };
            
        }
      
    });

    await Promise.all(validationPromises);


  return errs;
};
